import { render, staticRenderFns } from "./EmailBind.vue?vue&type=template&id=7970eafa&"
import script from "./EmailBind.vue?vue&type=script&lang=js&"
export * from "./EmailBind.vue?vue&type=script&lang=js&"
import style0 from "./EmailBind.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports